module.exports = __webpack_public_path__ + "img/head1.2086d16f.png";